import { render, staticRenderFns } from "./NotMobile.vue?vue&type=template&id=b5a169fc&scoped=true"
import script from "./NotMobile.vue?vue&type=script&lang=ts"
export * from "./NotMobile.vue?vue&type=script&lang=ts"
import style0 from "./NotMobile.vue?vue&type=style&index=0&id=b5a169fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a169fc",
  null
  
)

export default component.exports